import React from 'react'
import { connect } from 'react-redux';
import './DisconnectingServiceHeader.scss';
import { Container, Row, Col } from 'reactstrap';

function DisconnectingServiceHeader(props) {

    return (
        <div className="service-details-header-root">
            <div className="service-header-container">
                <div className="single-service-row">
                {props.serviceToDisconnect.serviceType == "Cellular" ? <div className="strong-data">{props.serviceToDisconnect.title} {props.serviceToDisconnect.subscriberNumber}</div>  : <div className="strong-data">{props.serviceToDisconnect.title}</div>}
                </div>
                <div className="triple-service-row">
                    <div className="service-item">{props.serviceToDisconnect.email}</div>
                    <div className="service-item">מספר לקוח: {props.serviceToDisconnect.customerId}</div>
                    <div className="service-item-last">בכתובת: {props.serviceToDisconnect.address}</div>
                </div>
            </div>
        </div>
    )
}


const mapStateToProps = (state) => ({
    serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect
});
  
export default connect(mapStateToProps, null)(DisconnectingServiceHeader);